module.exports = __webpack_public_path__ + "img/80.b3ac0c97.jpg";